import {
  HeroSection,
  FeaturesSection,
  UseCasesSection,
  CtaSection,
} from "@/components/product/multi-agent"
import { FooterSection } from "@/components/home/footer"
import { usePageTitle } from "@/hooks/use-page-title"

/**
 * Multi-Agent Orchestration product page.
 * Showcases the AI team coordination capabilities with Lead Agent orchestration.
 */
export function MultiAgentProductPage() {
  const pageTitle = usePageTitle(
    "Multi-Agent Orchestration",
    "Build AI teams that work together. Your Lead Agent intelligently routes tasks to specialized agents, enabling seamless collaboration at scale."
  )

  return (
    <div className="w-full">
      {pageTitle}
      <HeroSection />
      <FeaturesSection />
      <UseCasesSection />
      <CtaSection />
      <FooterSection />
    </div>
  )
}

MultiAgentProductPage.displayName = "MultiAgentProductPage"
